module.exports = __webpack_public_path__ + "static/img/saved.2fe99b55.png";